<template>
  <!-- 基金信息 -->
  <div>
    <div class="pb36" v-if="!isReadonly">
      <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="addHandle" class="fs12">{{ $t("enroll.questionnaire.addFundInformation") }}</el-button>
    </div>

    <div v-if="innerList.length != 0">
      <el-table :data="innerList" border class="wdb100">
        <el-table-column prop="fundName" :label="$t('enroll.questionnaire.proposedFundName')" align="center"></el-table-column>
        <el-table-column prop="fundType" :label="$t('enroll.questionnaire.fundType')" align="center">
          <template slot-scope="scope">
            <p>{{ getGlobalLabel("fundTypeList", scope.row.fundType) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="fundRegistrationCountry" :label="$t('enroll.questionnaire.registrationCountry')" align="center">
          <template slot-scope="scope">
            <p>{{ getGlobalLabel("countryList", scope.row.fundRegistrationCountry) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="fundRegistration" :label="$t('enroll.questionnaire.registrationAddress')" align="center"></el-table-column>
        <el-table-column :label="$t('common.operation')" align="center">
          <template slot-scope="scope">
            <template v-if="isReadonly">
              <span class="blue fs14 crp fwb" @click="editHandle(scope.$index, scope.row)">
                <i class="el-icon-view"></i>
                {{ $t("common.button.view") }}
              </span>
            </template>
            <template v-else>
              <el-button type="text" icon="el-icon-edit" class="mr6" @click="editHandle(scope.$index, scope.row)">{{ $t("common.button.edit") }}</el-button>
              <el-button type="text" icon="el-icon-delete" class="red" @click="deleteHandle(scope.$index, scope.row)">{{ $t("common.button.delete") }}</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新建/编辑 - 弹窗 -->
    <add-or-update :isReadonly="isReadonly" ref="addOrUpdateRef" @update="updateItem"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate.vue";
import { mapGetters } from "vuex";

export default {
  name: "FundInformation",
  components: { AddOrUpdate },
  props: {
    /** v-model 绑定值：基金信息数组 */
    value: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("constant", ["getGlobalLabel"]),
    /** 内部列表，与 value 保持同步 */
    innerList() {
      return this.value || [];
    },
  },
  methods: {
    /** 同步变更到父组件 */
    emitInput(newList, extraPayload) {
      this.$emit("input", newList);
      // 当删除或修改时，通知父组件同步更新基金的直接股东/董事信息
      if (extraPayload) {
        this.$emit("fund-change", extraPayload);
      }
    },
    // 新建
    addHandle() {
      this.$refs.addOrUpdateRef.init("add");
    },
    // 编辑
    editHandle(index, row) {
      this.$refs.addOrUpdateRef.init(index, row);
    },
    // 删除
    deleteHandle(index, row) {
      const list = [...this.innerList];
      const deletedFundName = list[index].fundName;
      list.splice(index, 1);
      this.emitInput(list, { action: "delete", deletedFundName, newList: list });
    },
    // 更新（新增或编辑回调）
    updateItem(obj, index) {
      let list = JSON.parse(JSON.stringify(this.innerList));
      if (index === "add") {
        list.push(obj);
        this.emitInput(list, { action: "add", addedObj: obj });
      } else {
        const oldFundName = list[index].fundName;
        list.splice(index, 1, obj);
        this.emitInput(list, { action: "edit", oldFundName, updatedObj: obj });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
